module.exports = __webpack_public_path__ + "static/media/record-video-multimedia-svgrepo-com.77804094.svg";